<template>
    <dashboard-layout>
        <basic-card>
            <data-table
                :data="partyRoleTypes"
                :configuration="partyRoleTypeTableConfig"
                @focusedChanged="handleFocusedChanged"
                component-id="party-role-types-list"
            />
        </basic-card>
        <br/>
        <basic-card>

        </basic-card>
    </dashboard-layout>
</template>

<script>
    import DataTable from "../components/table/DataTable";
    import {mapGetters} from "vuex";
    import BasicCard from "../components/layout/BasicCard";
    import DashboardLayout from "../components/layout/DashboardLayout";
    export default {
        name: "PartyRoleTypesView",
        components: {DashboardLayout, BasicCard, DataTable},
        data: function () {
            return {
                focused: null,
                partyRoleTypeTableConfig: {
                    selectionMode: "single",
                    columns: [
                        {
                            caption: "Id",
                            datum: d => d.id
                        },
                        {
                            caption: "System name",
                            datum: d => d.systemName
                        },
                        {
                            caption: "Display name",
                            datum: d => d.displayName
                        }
                    ]
                }
            }
        },
        methods: {
            handleFocusedChanged(item) {
                this.focused = item;
            }
        },
        created() {

        },
        computed: {
            ... mapGetters({
               partyRoleTypes: "partyRoleTypes/partyRoleTypes"
            })
        }
    }
</script>

<style lang="scss" scoped>

</style>